import articleSeoGuidanceData from "./articleSeoGuidance.json";
import { getRatgeberArticle } from "./ratgeberArticles";
import { seoTopicClusters } from "./seoTopicClusters";

export const articleSeoGuidance = articleSeoGuidanceData;

export const getArticleSeoGuidance = (slug) => articleSeoGuidance[slug] || null;

export const getArticleGuidanceLinks = (slug) => {
  const guidance = getArticleSeoGuidance(slug);

  if (!guidance?.linkSlugs?.length) return [];

  return guidance.linkSlugs
    .map((linkSlug) => getRatgeberArticle(linkSlug))
    .filter(Boolean);
};

export const getGuidanceCluster = (slug) => {
  const guidance = getArticleSeoGuidance(slug);

  if (!guidance?.clusterId) return null;

  return seoTopicClusters.find((cluster) => cluster.id === guidance.clusterId) || null;
};

export const getGuidanceKeywords = (article) => {
  const guidance = getArticleSeoGuidance(article.slug);

  return Array.from(
    new Set([
      ...(article.keywords || []),
      ...(article.seoKeywords || []),
      guidance?.primaryKeyword,
      ...(guidance?.secondaryKeywords || []),
    ].filter(Boolean)),
  );
};

export const getGuidanceLastReviewedAt = (article) => {
  const guidance = getArticleSeoGuidance(article.slug);
  const dates = [article.updatedAt, guidance?.lastReviewedAt].filter(Boolean).sort();

  return dates.at(-1) || article.updatedAt;
};
